/**
 * 课程卡片模式切换
 */
export default {
  modeNames: {
    list: 'Mode liste',
    card: 'Mode carte',
  },
}
